import SectionHeading from "@/components/base/SectionHeading";
import { relatedFilms } from "@/mocks/movie";

export default function Related() {
  return (
    <section id="related" className="w-full bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-16 md:py-24">
        <SectionHeading
          align="left"
          eyebrow="More Like This"
          title="如果你是这部片子的观众，可能也会喜欢"
          description="同样聚焦家庭关系与人物内心的五部作品，按题材相近度整理。"
        />

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6">
          {relatedFilms.map((film) => (
            <article key={film.title} className="group">
              <div className="w-full aspect-[2/3] rounded-lg overflow-hidden border border-background-200">
                <img
                  src={film.image}
                  alt={`影片《${film.title}》海报`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <h3 className="mt-3 font-heading text-sm md:text-base font-bold text-foreground-950">
                {film.title}
              </h3>
              <p className="mt-1 text-[11px] md:text-xs text-primary-600">{film.meta}</p>
              <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{film.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}